import {Controller} from "@stimulus/core"

export default class PropertyPreviewController extends Controller {
    static targets = ["checkbox"];

    private readonly checkboxTargets: HTMLInputElement[];

    toggleAll(event) {
        const checked = event.target.checked
        this.checkboxTargets.forEach(cb => { cb.checked = checked });
    }
}